import { render } from "./SpotifyLogin.vue?vue&type=template&id=618c75bb"
import script from "./SpotifyLogin.vue?vue&type=script&lang=js"
export * from "./SpotifyLogin.vue?vue&type=script&lang=js"

import "./SpotifyLogin.vue?vue&type=style&index=0&id=618c75bb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__